import { useTheme } from '@mui/system'
import { DatePicker, LocalizationProvider, DatePickerProps } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import React, { useState } from 'react'
import CustomTextField from './CustomTextField'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import cs from 'date-fns/locale/cs'

interface CustomDatePickerProps extends Omit<DatePickerProps<Date, null>, 'renderInput'> {
    canBeCanceled?: boolean
}

const CustomDatePicker: React.FC<CustomDatePickerProps> = ({ canBeCanceled = true, ...props }: CustomDatePickerProps) => {
    const theme = useTheme()
    const [isDatePickerOpen, setIsDatePickerOpen] = useState<boolean>(false)

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={cs}>
            <DatePicker
                {...props}
                onOpen={() => setIsDatePickerOpen(true)}
                onClose={() => setIsDatePickerOpen(false)}
                renderInput={(params) => (
                    <CustomTextField fullWidth size='small' onClick={() => setIsDatePickerOpen(true)} {...params} />
                )}
                value={!props.value ? null : new Date(new Date(props.value).setHours(1, 0, 0, 0))}
                open={isDatePickerOpen}
                components={{
                    OpenPickerIcon: () =>
                        canBeCanceled ? (
                            <div
                                onClick={() => props.onChange(null)}
                                style={{ display: props.value ? '' : 'none', marginTop: theme.spacing(1) }}
                            >
                                {<CloseOutlinedIcon />}
                            </div>
                        ) : null,
                }}
            />
        </LocalizationProvider>
    )
}

export default CustomDatePicker
